<div
  class="modal fade show d-block"
  tabindex="-1"
  role="dialog"
  style="background: rgba(0, 0, 0, 0.5);"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">{{ titulo }}</h5>
      </div>

      <div class="modal-body">
        <ng-content></ng-content>
      </div>

      <div class="modal-footer">
        <button *ngIf="btnCerrar" class="btn btn-secondary" (click)="onCerrar()" title="Cerrar modal">{{ labelBtnCerrar }}</button>
        <button *ngIf="btnAceptar" class="btn btn-primary" (click)="onAceptar()" [disabled]="loading" title="Ejecutar acción">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
          {{ labelBtnAceptar }}
        </button>
      </div>

    </div>
  </div>
</div>
